import { useEffect } from 'react';

/**
 * A simple component whose only purpose is to redirect the user to an
 * external URL. It uses a useEffect hook at the top level, which
 * complies with the Rules of Hooks.
 * @param {object} props - The component's props.
 * @param {string} props.to - The full external URL to redirect to.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    // When this component mounts, it will trigger the redirect.
    if (to) {
      window.location.href = to;
    }
  }, [to]); // The effect runs whenever the 'to' prop changes.

  // Return a fallback message for the user to see while the browser redirects.
  return <div>Redirecting to login...</div>;
};

export default ExternalRedirect;
